<script lang="ts">
  import Button from "$app/components/ButtonSpinner.svelte"

  interface Props {
    department: DepartmentType
    saving?: boolean
    buttonMsg?: string
    error?: string
    ondata: (data: DepartmentType) => void
    oncancel: () => void
  }

  let {
    department,
    saving = false,
    buttonMsg = "Update",
    error = "",
    ondata,
    oncancel
  }: Props = $props()

  let form = $state({ name: department.name })
</script>

<div class="flex items-center">
  <div
    class="flex-1 px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
  >
    <input
      type="text"
      bind:value={form.name}
      placeholder="Department name"
      class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
    />
    <div class="text-red-500">
      {error || ""}
    </div>
  </div>
  <div class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
    <Button
      class="btn primary ml-2"
      processing={saving}
      onclick={() => ondata(form)}
    >
      {buttonMsg}
    </Button>
    <Button
      class="btn secondary ml-2"
      processing={saving}
      onclick={() => oncancel()}
    >
      Cancel
    </Button>
  </div>
</div>
